(function () {
  function moveEstimatedDeliveryWidget(root) {
    var scope = root || document;
    var productInfos = scope.querySelectorAll('product-info');

    productInfos.forEach(function (productInfo) {
      var paymentIcons = productInfo.querySelector('.payment-icon-block');
      var deliveryEmbed = productInfo.querySelector('essential-estimated-delivery-app-embed');

      if (!paymentIcons || !deliveryEmbed) {
        return;
      }

      if (deliveryEmbed.previousElementSibling === paymentIcons) {
        deliveryEmbed.dataset.codexDeliveryMoved = 'true';
        return;
      }

      paymentIcons.insertAdjacentElement('afterend', deliveryEmbed);
      deliveryEmbed.dataset.codexDeliveryMoved = 'true';
    });
  }

  function startEstimatedDeliveryObserver() {
    moveEstimatedDeliveryWidget(document);

    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function () {
      moveEstimatedDeliveryWidget(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('shopify:section:load', function (event) {
      moveEstimatedDeliveryWidget(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEstimatedDeliveryObserver, { once: true });
  } else {
    startEstimatedDeliveryObserver();
  }
})();
